import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-campaign-popup',
  templateUrl: './campaign-popup.component.html',
  styleUrls: ['./campaign-popup.component.css'],
})
export class CampaignPopupComponent implements OnInit {

    cdTimerHours: string = '00';
    cdTimerMinutes: string = '00';
    cdTimerSeconds: string = '00';
    cdTimerStartEndLabel: string = 'common.OfferStartingIn';
    cdTimer: any;
    mobileView: boolean = false;
    cdTimerSubscription: Subscription;

    constructor(
      public translate: TranslateService,
      private dialogRef: MatDialogRef<CampaignPopupComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: {
        timerStream: any;
      }
    ) {}
  
    ngOnInit(): void {
      if (window.screen.width < 960) {
        this.mobileView = true;
      }

      this.cdTimerSubscription = this.data.timerStream.subscribe(time => {
        this.cdTimerHours = time.hrs;
        this.cdTimerMinutes = time.mins;
        this.cdTimerSeconds = time.secs;
        this.cdTimerStartEndLabel = time.cdTimerStartEndLabel;

        if (time.hrs == "00" && time.mins == "00" && time.secs == "00" && time.status == "ONGOING") {
          this.closeDialog();
        }
      });
    }

    ngOnDestroy(): void {
      if (this.cdTimerSubscription) {
        this.cdTimerSubscription.unsubscribe();
      }
    }

    closeDialog() {
    if (this.cdTimerSubscription) {
      this.cdTimerSubscription.unsubscribe();
    }

    this.dialogRef.close();
  }
}
